<template>
  <tbody>
  <tr :class="['clickable', {disabled: !entity.active,  updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <td :data-th="'Název' | translate">
      <strong>{{ entity.name }}</strong>
    </td>
    <td :data-th="'Poskytovatel videa' | translate">
      <entity-link :id="entity.id_vod_provider" type="vodProvider">{{ entity.vod_provider_name }}</entity-link>
    </td>
    <td :data-th="'Počet videí' | translate">
      {{ entity.videos_count }}
    </td>
    <td :data-th="'Maximální počet videí' | translate">
      {{ maxVideoCount }}
    </td>
    <td :data-th="'Poskytováno od' | translate">
      {{ $_date_format(entity.provided_from) }}
    </td>
    <td :data-th="'Poskytováno do' | translate">
      {{ $_date_format(entity.provided_to) }}
    </td>
    <td></td>
  </tr>
  </tbody>
</template>

<script>
import rowActions from "../../mixins/row-actions";
import EntityLink from "../../common/EntityLink.vue";

export default {
  name: "VodPackagesRow",
  components: { EntityLink },
  mixins: [rowActions],
  props: {
    entity: Object,
  },
  data(){
    return{
      detailPageRouteName: "vodPackagesDetail",
    }
  },
  computed: {
    maxVideoCount(){
      return this.entity.maximum_number_of_videos ? this.entity.maximum_number_of_videos: this.$gettext('Neuvedeno');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/vodPackages/VodPackagesRow.vue